import { render } from "./Fehler.vue?vue&type=template&id=7f4e4780"
import script from "./Fehler.vue?vue&type=script&lang=js"
export * from "./Fehler.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Bleckmann\\lions-adventskalender-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__